import React, {Component} from 'react';
import axios from 'axios'

import './contact-form.css';

const url = "https://formspree.io/nicholas@athenaeg.com";
const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

class ContactForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isFormPending: false,
      isFormSubmitted: false,
      isFormValid: false,
      isFirstNamePresent : false,
      isLastNamePresent : false,
      isEmailPresent : false,
      isEmailValid : false,
      isSubjectPresent: false,
      isMessagePresent: false,
    };

    this.validateAndSubmit = this.validateAndSubmit.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.formSubmit = this.formSubmit.bind(this);
  }

  validateAndSubmit (e){
    e.preventDefault();

    let isInvalid = !this.validateForm();

    if (isInvalid) {
      return;
    }

    this.formSubmit();
  }

  validateForm() {
    let isFirstNameValid = this.validateFirstName();
    let isLastNameValid = this.validateLastName();
    let isEmailValid = this.validateEmail();
    let isSubjectValid = this.validateSubject();
    let isMessageValid = this.validateMessage();

    let isFormValid = (isFirstNameValid && isLastNameValid && isEmailValid &&
                       isSubjectValid && isMessageValid);

    this.setState({isFormInvalid: !isFormValid});

    return isFormValid;
  }

  formSubmit() {
    this.setState({isPending: true});

    let form = document.querySelector('form');
    let firstName = this.firstNameRef.value;
    let lastName = this.lastNameRef.value;
    let email = this.emailRef.value;
    let subject = this.subjectRef.value;
    let message = this.messageRef.value;

    axios.post(url, {
      data: {
        "First_Name": firstName,
        "Last_Name": lastName,
        "Email": email,
        "Subject": subject,
        "Message": message,
      }
    })
    .then(function(response) {
      console.log(response);
      this.setState({isFormSubmitted: true, isFormPending: false});
      }.bind(this)
    )
    .catch(function(error) {
      console.log(error);
      alert('Error occured');
    });
  }

  validateFirstName() {
    let isFirstNamePresent = this.firstNameRef.value != '';
    this.setState({isFirstNamePresent : isFirstNamePresent});
    return isFirstNamePresent;
  }

  validateLastName() {
    let isLastNamePresent = this.lastNameRef.value != '';
    this.setState({isLastNamePresent : isLastNamePresent});
    return isLastNamePresent;
  }

  validateEmail() {
    let isEmailPresent = this.emailRef.value != '';
    let isEmailValid = emailRegex.test(this.emailRef.value);
    this.setState({isEmailPresent : isEmailPresent});
    this.setState({isEmailValid : isEmailValid});
    return isEmailPresent && isEmailValid;
  }

  validateSubject() {
    let isSubjectPresent = this.subjectRef.value != '';
    this.setState({isSubjectPresent : isSubjectPresent});
    return isSubjectPresent;
  }

  validateMessage() {
    let isMessagePresent = this.messageRef.value != '';
    this.setState({isMessagePresent : isMessagePresent});
    return isMessagePresent;
  }

  generateErrorMessage(condition, text) {
    let shouldDisplayErrorMessages = this.state.isFormInvalid;
    return (
      <div className="invalid-message" style={{display: condition && shouldDisplayErrorMessages ? 'inline-block' : 'none'}}>
        {text}
      </div>
    );
  }

  generateInputTag(text, isClickable, style) {
    return (
      <div style= {style} className = {isClickable ? "clickable" : ""}>
        {text} *
      </div>
    );
  }

  generateClickableInputTag(text, style) {
    return this.generateInputTag(text, true, style);
  }

  render() {
    let data = this.props.data;
    let {isFormPending, isFormSubmitted, isFormInvalid,
      isFirstNamePresent, isLastNamePresent, isEmailPresent,
      isEmailValid, isSubjectPresent, isMessagePresent} = this.state;

    let largeTagStyle = {fontSize: 14};
    let smallTagStyle = {fontSize: 12};

    if (isFormSubmitted) {
      return (
        <div>
          {data.submissionMessage}
        </div>
      );
    }

    return (
      <div className="contact-form">
      <form action="https://formspree.io/nicholas@athenaeg.com" method="POST">
        {this.generateErrorMessage(isFormInvalid, data.invalidFormMsgTop)}

        {this.generateErrorMessage(!isFirstNamePresent && !isLastNamePresent, data.missingFirstAndLastNameMsg)}
        {this.generateErrorMessage(!isFirstNamePresent && isLastNamePresent, data.missingFirstNameMsg)}
        {this.generateErrorMessage(isFirstNamePresent && !isLastNamePresent, data.missingLastNameMsg)}
        {this.generateInputTag(data.name, false, largeTagStyle)}
        <input type="hidden" name="_format" value="plain" />
        <input type="hidden" name="_next" value="about" />

        <div className="clearfix">

          <div style={{width: '49%', float: 'left'}} onClick={() => this.firstNameRef.focus()}>
            <input name="First Name" type="text" className="form-elem" ref={(input) => this.firstNameRef = input} />
            {this.generateClickableInputTag(data.firstName, smallTagStyle)}
          </div>

          <div style={{width: '48%', float: 'right'}} onClick={() => this.lastNameRef.focus()}>
            <input name="Last Name" type="text" className="form-elem" ref={(input) => this.lastNameRef = input} />
            {this.generateClickableInputTag(data.lastName, smallTagStyle)}
          </div>
        </div>

        {this.generateErrorMessage(!isEmailPresent, data.missingEmailMsg)}
        {this.generateErrorMessage(isEmailPresent && !isEmailValid, data.invalidEmailMsg)}

        <div className="form-input-container" onClick={() => this.emailRef.focus()}>
          {this.generateClickableInputTag(data.email, largeTagStyle)}
          <input name="Email" id="email" type="text" className="form-elem" ref={(input) => this.emailRef = input} />
        </div>

        {this.generateErrorMessage(!isSubjectPresent, data.missingSubjectMsg)}

        <div className="form-input-container" onClick={() => this.subjectRef.focus()}>
          {this.generateClickableInputTag(data.subject, largeTagStyle)}
          <input name="Subject" type="text" className="form-elem" ref={(input)=> this.subjectRef = input} />
        </div>

        {this.generateErrorMessage(!isMessagePresent, data.missingMessageMsg)}

        <div className="form-input-container" onClick={() => this.messageRef.focus()}>
          {this.generateClickableInputTag(data.message, largeTagStyle)}
          <textarea name="Message" rows="4" className="form-elem" ref={(input) => this.messageRef = input} />
        </div>

        <div className="form-input-container">
          <button className="submit-button">{data.submit}</button>
        </div>

        {this.generateErrorMessage(isFormInvalid, data.invalidFormMsgBottom)}
      </form>
      </div>
    );
  }
}

export default {ContactForm}



// WEBPACK FOOTER //
// ./src/components/Contact/contact-form.js